export default {
  'home-card-button':
    'border-solid border-black rounded-none border-2 sm:text-5.2v md:text-20 px-30 py-12  sm:my-34 md:mt-0 md:mb-0 sm:inline-block md:relative font-BebasNeueRegular no-underline text-black get-started',
  'look-inside-button':
    'look-inside-button',
  'home-card-button-discover':
    'border-solid border-black rounded-none border-2 sm:text-5.2v md:text-20 px-30 py-12  sm:my-34 md:mt-0 md:mb-0 sm:inline-block md:relative font-BebasNeueRegular no-underline text-black discover-button md:mt-40',
  'home-Explore-button':
    'border-solid border-black rounded-none border-2 sm:text-5.2v md:text-20 px-30 sm:my-30 py-12 md:mb-0 md:relative font-BebasNeueRegular no-underline text-black get-started sm:mx-auto md:mx-auto sm:inline-block md:mt-40 sm:mt-0 md:mb-0 sm:mt-50',
  'learn-more':
    'font-BebasNeueRegular m-auto block mb-62 text-18 leading-30 tracking-wider font-bold sm:pt-12 md:pt-0 gradient-line table text-black',
  'discover-more-btn':
    'discover-more-btn text-16 font-BebasNeueRegular px-22 py-7 inline-block text-black lg:tracking-0.48 no-underline',
  footerHeader:
    'footerHeader text-16 font-BebasNeueBold no-underline cursor-auto',
    nossosIngredientBtn: 'text-14 text-white my-20 px-10 md:px-30 py-7 md:py-5  font-BebasNeueRegular novaButtonText relative block float-left bg-gradient rounded-20 ct-style',
    'vitaminproBtn':'text-14 text-white my-20 px-10 md:px-30 py-7  md:py-5 font-BebasNeueRegular novaButtonText block float-left bg-gradient bg-pos -pt-50  rounded-20'
};
